import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * /admin/tenant/leaseedit/:id — preserved as a redirect-only component.
 *
 * The dedicated Edit Lease page has been folded into Edit Tenant's
 * Tenancy section (gated by the manageLeaseDetails permission, see
 * EditTenant/TenantEdit.jsx). Bookmarks and external links to the old
 * /leaseedit/:id URL still land here, then bounce to the canonical
 * /tenantedit/:id#tenancy URL, which auto-scrolls to the Tenancy
 * section on arrival.
 */
const LeaseEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (!id) return;
        navigate(`${process.env.PUBLIC_URL}/admin/tenant/tenantedit/${id}#tenancy`, { replace: true });
    }, [id, navigate]);
    return null;
};

export default LeaseEdit;
